import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ResultPage } from '@app/core/data';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TenantSettingDto } from '../model/tenant-setting';

@Injectable({
  providedIn: 'root',
})
export class TenantSettingsService {
  protected readonly baseUrl = `${environment.apiUrl}`;
  private readonly http = inject(HttpClient);

  public getForTenant(): Observable<ResultPage<TenantSettingDto>> {
    return this.http.get<ResultPage<TenantSettingDto>>(
      `${this.baseUrl}/tenant-settings`
    );
  }
}
